// extracted by mini-css-extract-plugin
module.exports = {"head":"FilesFlatList_head__o_yA5"};